export const BACKEND_URL = 'https://compute.ilsp.gr:5010';
export const TRANCRIPTION_WSS_URL = 'wss://compute.ilsp.gr:5010/ws';
export const CHATBOT_WSS_URL = 'wss://compute.ilsp.gr:8668';
export const BASEPATH = '/justredi'
export const PRODUCTION = true
